import React, { useState } from "react";
import InputFactory from "../../../../../components/InputFactory";

export default function FilterGenerator({
  schema,
  onSubmit,
  justify = "end",
  searchBtnDisabled,
}) {
  // Initialize state for filter inputs
  const [filters, setFilters] = useState(() => {
    // Initialize the filters state with an empty string for each filter field
    return schema.filters.reduce((acc, filter) => {
      acc[filter] = "";
      return acc;
    }, {});
  });

  // // Validation function to remove numbers, special characters, and trim spaces, and convert to uppercase
  // const sanitizeInput = (value) => {
  //   // Allow only alphabets and spaces, remove trailing spaces, and convert to uppercase
  //   return (
  //     value
  //       .replace(/[^a-zA-Z\s]/g, "")
  //       // .trim()
  //       .toUpperCase()
  //   );
  // };
  // const sanitizeInput = (value) => {
  //   return (
  //     value
  //       // Allow only A-Z, a-z, Ñ, ñ, and space characters
  //       .replace(/[^A-Za-zÑñ\s]/g, "")
  //       // Replace multiple spaces with a single one
  //       .replace(/\s+/g, " ")
  //       .toUpperCase()
  //       .trim()
  //   );
  // };
  const sanitizeInput = (value) => {
    return (
      value
        // Allow letters (A–Z, Ñ/ñ), spaces, periods, and hyphens only
        .replace(/[^A-Za-zÑñ\s.\-]/g, "")
        .replace(/\s+/g, " ") // collapse multiple spaces into one
        .toUpperCase()
    );
  };

  // const sanitizeInput = (value) => {
  //   return (
  //     value
  //       // Allow letters (A–Z, Ñ/ñ), spaces, and periods only
  //       .replace(/[^A-Za-zÑñ\s.]/g, "")
  //       .replace(/\s+/g, " ") // collapse multiple spaces into one
  //       .toUpperCase()
  //   );
  // };

  // const sanitizeInput = (value) => {
  //   return (
  //     value
  //       // Allow letters (A–Z, Ñ/ñ) and spaces only
  //       .replace(/[^A-Za-zÑñ\s]/g, "")
  //       .replace(/\s+/g, " ") // collapse multiple spaces into one
  //       .toUpperCase()
  //   );
  // };

  // Validation function to remove numbers, special characters, and trim spaces, and convert to uppercase
  // const sanitizeInput = (value) => {
  //   return (
  //     value
  //       // allow A–Z, a–z, Ñ, ñ, and spaces only
  //       .replace(/[^A-Za-zÑñ\s]/g, "")
  //       .toUpperCase()
  //       .trim()
  //   );
  // };

  // Handle input change for each filter
  // const handleInputChange = (fieldName, value) => {
  //   const sanitizedValue = sanitizeInput(value); // Sanitize and convert the input to uppercase
  //   setFilters((prevFilters) => ({
  //     ...prevFilters,
  //     [fieldName]: sanitizedValue, // Update the corresponding field value
  //   }));
  // };
  const handleInputChange = (fieldName, value) => {
    const sanitizedValue = sanitizeInput(value);
    setFilters((prevFilters) => ({
      ...prevFilters,
      [fieldName]: sanitizedValue,
    }));
  };

  // Format the filters for rendering
  // const formattedFilters = () => {
  //   return schema.filters.map((filter) => {
  //     const field = schema.fields[filter];
  //     return {
  //       ...field,
  //       fieldName: filter,
  //       placeholder: `${field.label}`,
  //     };
  //   });
  // };
  const formattedFilters = () => {
    return schema.filters
      .filter((filter) => filter !== "company") // Exclude the "company" filter
      .map((filter) => {
        const field = schema.fields[filter];
        return {
          ...field,
          fieldName: filter,
          placeholder: `${field.label}`,
        };
      });
  };

  // Check if any input field has a value
  const isSearchDisabled = () => {
    return Object.values(filters).every((value) => value === "");
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(filters); // Pass the filters state to the onSubmit callback
  };

  return (
    <form
      className={`row d-flex justify-content-${justify}`}
      style={{ width: "100%" }}
      onSubmit={handleSubmit}
    >
      {formattedFilters().map((field) => {
        const { type, fieldName, ...options } = field;
        return (
          <div
            className={`${
              fieldName === "alias" || fieldName === "middleName"
                ? "col-2"
                : "col-3"
            } position-relative d-flex align-items-center`}
            key={fieldName}
          >
            {type === "String" ? (
              <i
                className="bi bi-search position-absolute"
                style={{ right: "1.5rem", zIndex: 2 }}
              ></i>
            ) : null}
            <InputFactory
              type={type}
              field={fieldName}
              style={{ paddingRight: type === "String" ? "2.2rem" : "" }}
              className="col-4"
              value={filters[fieldName]} // Set the value from the state
              onChange={(value, field) => handleInputChange(field, value)} // Update state on input change
              {...options}
              {...(fieldName === "alias" ? { placeholder: "Extension" } : {})}
              _required={false}
            />
          </div>
        );
      })}
      <div className="col-2">
        <button
          type="submit"
          // disabled={searchBtnDisabled}
          className="btn btn-secondary"
          disabled={searchBtnDisabled}
        >
          Search
        </button>
      </div>
    </form>
  );
}
